import React, { useEffect, useRef, useState } from "react";
import "../styles/UserLogModal.css";

const UserLogModal = ({ open, user, logLines = [], loading, error, onClose, onRefresh }) => {
  const bodyRef = useRef(null);
  const lastScrollTopRef = useRef(0);
  const [autoScroll, setAutoScroll] = useState(true);

  useEffect(() => {
    if (!open) return;
    const el = bodyRef.current;
    if (!el) return;
    if (!autoScroll) return;
    const raf = requestAnimationFrame(() => {
      el.scrollTop = el.scrollHeight;
      lastScrollTopRef.current = el.scrollTop;
    });
    return () => cancelAnimationFrame(raf);
  }, [open, logLines.length, loading, autoScroll]);

  useEffect(() => {
    if (open) {
      setAutoScroll(true);
    }
  }, [open]);

  const handleScroll = () => {
    if (!bodyRef.current) return;
    const { scrollTop, scrollHeight, clientHeight } = bodyRef.current;
    const nearBottom = scrollHeight - scrollTop - clientHeight < 24;
    const prevTop = lastScrollTopRef.current;
    const scrollingUp = scrollTop < prevTop;
    lastScrollTopRef.current = scrollTop;
    if (scrollingUp) {
      setAutoScroll((prev) => (prev ? false : prev));
      return;
    }
    setAutoScroll((prev) => (prev === nearBottom ? prev : nearBottom));
  };

  if (!open) return null;

  return (
    <div className="user-log-backdrop" onClick={() => onClose?.()}>
      <div className="user-log-modal" onClick={(event) => event.stopPropagation()}>
        <header className="user-log-header">
          <div>
            <h3>Console</h3>
            <p>{user || "Usuario"}</p>
          </div>
          <div className="user-log-actions">
            <button type="button" className="user-log-refresh" onClick={onRefresh} disabled={loading}>
              {loading ? "Cargando..." : "Refrescar"}
            </button>
            <button type="button" className="user-log-close" onClick={() => onClose?.()}>
              ✕
            </button>
          </div>
        </header>

        {error ? <div className="user-log-alert">{error}</div> : null}

        <div className="user-log-body" ref={bodyRef} onScroll={handleScroll}>
          {loading && logLines.length === 0 ? (
            <div className="user-log-empty">Cargando log...</div>
          ) : logLines.length === 0 ? (
            <div className="user-log-empty">Sin datos en el log.</div>
          ) : (
            <pre className="user-log-content">
              {logLines.join("\n")}
            </pre>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserLogModal;
